import { render, staticRenderFns } from "./insertData.vue?vue&type=template&id=9417a502&scoped=true&"
import script from "./insertData.vue?vue&type=script&lang=js&"
export * from "./insertData.vue?vue&type=script&lang=js&"
import style0 from "./insertData.vue?vue&type=style&index=0&id=9417a502&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9417a502",
  null
  
)

export default component.exports